<div class="container-body">
    <div class="background-color"></div>
</div>
<div class="wrapper">
    <h2> مزایای اشتراک {{appParametersService.appName}} </h2>
    <div class="container-items">
        <div class="wrapper-items boder">
            <img src="assets/icon-new/headphone.svg">
            <div class="wrapper-title">
                <b>بدون محدودیت</b>
                <p>بدون محدودیت هر چقدر میخوای گوش کن</p>
            </div>
        </div>
        <div class="wrapper-items">
            <img src="assets/icon-new/internet.svg">
            <div class="wrapper-title">
                <b>بدون اینترنت</b>
                <p>بدون محدودیت هر چه قدر می خوای گوش کن</p>
            </div>
        </div>
        <div class="wrapper-items">
            <img src="assets/icon-new/security.svg">
            <div class="wrapper-title">
                <b>امنیت کامل</b>
                <p>بدون محدودیت هر چه قدر می خوای گوش کن</p>
            </div>
        </div>
        <div class="btn-style">
            <navaar-button
                [color-name]="'blue'"
                [type-button]="'button'"
                (onClick)="onClick($event)"
            >
                <span>خرید اشتراک</span>
            </navaar-button>
        </div>
    </div>
</div>
